




























import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class CommonSolution extends Vue {
  //
  navigationName = "" as any;
  classifyName = "" as any;
  classifyLink = "" as any;
  navigationLink = "" as any;
  list = {
    style: {
      "background-image": `url(${require("../../../../assets/data030.png")})`,
      height: "493px"
    },
    font1: "",
    font2: "",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  classify = "";
  title = "数字政府行业";
  content = "";

  mounted() {
    this.getSolutionDetail();
    this.getAllNavigation();
  }
  getSolutionDetail() {
    CommonService.getSolutionDetail({ id: this.$route.params.id }).then(
      (res: any) => {
        this.content = res.data.content;
      }
    );
  }
  getAllNavigation() {
    CommonService.getAllClassification({}).then((res: any) => {

      res.data[0].child.forEach((item: any) => {
        if (item.child) {
          item.child.forEach((element: any) => {
            if (element.id == this.$route.params.id) {
              this.classifyName = item.name;
              this.navigationName = res.data[0].name;
              this.navigationLink = "/enterprise/page";
              this.classifyLink = `/enterprise/industry/classify/${item.id}`;
              this.list.style["background-image"]=`url(${require("../../../../assets/industry-solution.jpg")})`
            }
          });
        }
      });
      res.data[2].child.forEach((item: any) => {
        if (item.child) {
          item.child.forEach((element: any) => {
            if (element.id == this.$route.params.id) {
              this.classifyName = item.name;
              this.navigationName = res.data[2].name;
              this.navigationLink = "/enterprise/digital/page";
              this.classifyLink = `/enterprise/digital/classify/${item.id}`;
              this.list.style["background-image"]=`url(${require("../../../../assets/digital-solution.jpg")})`
            }
          });
        }
      });
    });
  }
}
